import { Icon } from '@iconify/react';
import { useState } from 'react';

import { Botao, Campo } from '../components/Sga';
import { emailLembrado, persistenciaAtiva } from '../lib/api';
import { useAuth } from '../lib/auth';
import { RecuperarSenha } from './RecuperarSenha';

/**
 * Login local, para a equipe de infra da SGA.
 *
 * Em produção o caminho normal é o SSO: o SGA Desk/Gestor abre o painel numa
 * webview já autenticado, e esta tela nem aparece.
 */
export function Login() {
  const { entrar, erro: erroSessao } = useAuth();
  // Pré-enche o e-mail de quem marcou "Manter conectado" na última vez.
  const [email, setEmail] = useState(emailLembrado);
  const [senha, setSenha] = useState('');
  const [manterConectado, setManterConectado] = useState(
    () => persistenciaAtiva() || emailLembrado() !== '',
  );
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [recuperando, setRecuperando] = useState(false);

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);
    setOcupado(true);
    try {
      await entrar(email.trim(), senha, manterConectado);
    } catch (err) {
      // Mensagem única: não revelar se o e-mail existe.
      setErro('E-mail ou senha inválidos.');
      void err;
    } finally {
      setOcupado(false);
    }
  };

  if (recuperando) return <RecuperarSenha aoVoltar={() => setRecuperando(false)} />;

  return (
    <div className="sga-login">
      <form className="sga-login__card" onSubmit={enviar}>
        <div className="sga-login__head">
          <img src="/logos/sga-logotipo-branco.svg" alt="SGA Petro" style={{ height: 30 }} />
          <div style={{ fontSize: 19, fontWeight: 500, marginTop: 10 }}>Messenger</div>
          <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,.75)' }}>
            Painel de controle · plataforma omnichannel
          </div>
        </div>

        <div className="sga-login__body">
          {(erro || erroSessao) && (
            <div
              className="sga-aviso-warn"
              style={{ background: 'rgba(255,77,79,.12)', color: 'var(--sga-error)' }}
            >
              <Icon icon="mdi:alert-circle-outline" width={17} />
              {erro ?? erroSessao}
            </div>
          )}

          <Campo rotulo="E-mail" obrigatorio>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </Campo>

          <Campo rotulo="Senha" obrigatorio>
            <input
              className="input"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Campo>

          <label
            style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}
          >
            <input
              type="checkbox"
              checked={manterConectado}
              onChange={(e) => setManterConectado(e.target.checked)}
              style={{ accentColor: 'var(--sga-primary)' }}
            />
            Manter conectado neste computador
          </label>

          <Botao variante="primary" type="submit" disabled={ocupado} style={{ height: 40, fontSize: 15 }}>
            {ocupado ? 'Entrando…' : 'Entrar'}
          </Botao>

          <button
            type="button"
            className="btn btn-link"
            onClick={() => setRecuperando(true)}
            style={{ height: 30, fontSize: 13, alignSelf: 'center' }}
          >
            Esqueci minha senha
          </button>

          <span className="hint" style={{ textAlign: 'center' }}>
            Acesso pelo SGA Desk ou SGA Gestor não precisa desta tela — a sessão vem do
            sistema de origem.
          </span>
        </div>
      </form>
    </div>
  );
}
